module.exports = __webpack_public_path__ + "assets/img/3.6a97740f.jpg";